// extracted by mini-css-extract-plugin
var _1 = "CreateVerificationModal-module__animateUploadProgressBarWidth--Lwbc8";
var _2 = "CreateVerificationModal-module__animatedBackground--P5wki";
var _3 = "CreateVerificationModal-module__label--kTWRq";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "label" }
